<template>
  <div
    :id="platform !== 'browser' ? 'apps' : 'app'"
    :style="{}"
  >
    <router-view />
  </div>
</template>

<script>
import Vue from 'vue';
import { getApp } from './utils/util';

export default {
  name: 'App',
  data() {
    return {
      platform: Vue.Native.Platform,
      hasSign: false,
      wait: false,
      signModal: false,
    };
  },
  computed: {
  },
  watch: {
    $route(to) {
      Vue.Native && this.tools.callNative('recordRouterHistory', this.$root.$options.rootViewId, to.name);
    },
    status(newVal) {
      this.signModal = newVal;
    },
  },
  created() {
  },
  mounted() {
    Vue.Native.Platform !== 'browser' && this.tools.callNative('recordRouterHistory', this.$root.$options.rootViewId, 'Home');
    Vue.Native.Platform !== 'browser' && getApp().$on('goBack', (page) => {
      this.$router.push({
        name: page,
      });
    });
  },
  beforeDestroy() {
    Vue.Native && getApp().$off('goBack');
  },
  methods: {
  },
};
</script>

<style>
html,
body,
#app {
 width: 100%;
 /* height: 100%; */
 margin-left: 0px;
 margin-right: 0px;
 margin-top: 0px;
 margin-bottom: 0px;
 padding-left: 0px;
 padding-right: 0px;
 padding-top: 0px;
 padding-bottom: 0px;
}
#app {
 flex: 1;

}
</style>
